import { jsxs as n, jsx as e } from "react/jsx-runtime";
import * as o from "react";
import { MoreHorizontal as i } from "lucide-react";
import { P as c, a as l, B as d, b as m, S as p, c as f } from "./sidebar-59b82a61.js";
import { u as h } from "./use-layout-167c9584.js";
function b() {
  const { topNav: t } = h(), [s, a] = o.useState(!1);
  return o.useEffect(() => {
    a(!1);
  }, []), /* @__PURE__ */ n("div", { className: "flex items-center gap-2 text-sm", children: [
    /* @__PURE__ */ e("div", { className: "hidden font-medium text-muted-foreground md:inline-block", children: "地域振興部地域振興課" }),
    /* @__PURE__ */ n(c, { open: s, onOpenChange: a, children: [
      /* @__PURE__ */ e(l, { asChild: !0, children: /* @__PURE__ */ e(
        d,
        {
          variant: "ghost",
          size: "icon",
          className: "h-7 w-7 data-[state=open]:bg-accent",
          children: /* @__PURE__ */ e(i, {})
        }
      ) }),
      /* @__PURE__ */ e(
        m,
        {
          className: "w-56 overflow-hidden rounded-lg p-0",
          align: "end",
          children: /* @__PURE__ */ e(p, { collapsible: "none", className: "bg-transparent", children: /* @__PURE__ */ e(f, { children: t.map((r) => r) }) })
        }
      )
    ] })
  ] });
}
export {
  b as N
};
